// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.GoogleMapConfiguration.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React, { Component } from 'react';
import { observe } from 'mobx';
import connect from 'share/enhancers/Izenda.Connect';
import GridLayout from 'share/components/controls/Izenda.GridLayout';
import action from './Izenda.GoogleMapConfigurationActions';
import uiState from 'logic/Izenda.UiState';
import Panel from 'share/components/controls/Izenda.Panel';
import ScrollBox from 'share/components/controls/Izenda.ScrollBox';
import Label from 'share/components/controls/Izenda.Label';
import IzendaSwitch from 'share/components/controls/Izenda.Switch';

import SettingActionHeader from '../Izenda.SettingActionHeader';
import GoogleMapConfigInput from './Izenda.GoogleMapConfigInput';

import { isNil } from 'lodash/fp';


@connect(action)
export default class GoogleMapConfiguration extends Component {
  renderGoogleMapConfigurationContent() {
    const tenantId = uiState.tenantId;
    const { localization, onChangeGoogleMapSetting: onChange, store } = this.props;
    const {
      googleMapConfiguration: { googleApiKey, useSystemConfiguration, useGEOCodingService }
    } = store;
    return (
      <Panel className='u_marginTop panel-default Izenda_CachingInfo'>
        <GridLayout>
          {!isNil(tenantId) && (
            <GridLayout.Row>
              <GridLayout.Col cols={3}>
                <GoogleMapConfigInput
                  type='radio'
                  name='googleMapConfiguration'
                  dataKey='useSystemConfiguration'
                  value='useSystemConfiguration'
                  onChange={onChange}
                  checked={useSystemConfiguration}
                />
                <Label className='u_marginRight'>{localization.getText('GOOGLE_MAP_USE_SYSTEM_CONFIGURATION')}</Label>
              </GridLayout.Col>
              <GridLayout.Col cols={9}>
                <GoogleMapConfigInput
                  type='radio'
                  name='googleMapConfiguration'
                  dataKey='useCustomConfiguration'
                  value='useCustomConfiguration'
                  onChange={onChange}
                  checked={!useSystemConfiguration}
                />
                <Label className='u_marginRight'>{localization.getText('GOOGLE_MAP_USE_CUSTOM_CONFIGURATION')}</Label>
              </GridLayout.Col>
            </GridLayout.Row>
          )}
          {!useSystemConfiguration && (
            <GridLayout.Row className='Izenda_GoogleSetting_ConfigInput'>
              <GridLayout.Col cols={2}>
                <label className='u_marginLeft'>{localization.getText('GOOGLE_MAP_API_KEY')}</label>
              </GridLayout.Col>
              <GridLayout.Col cols={10}>
                <GoogleMapConfigInput
                  title={localization.getText('GOOGLE_MAP_API_KEY')}
                  type='text'
                  value={googleApiKey}
                  dataKey='googleApiKey'
                  onChange={onChange}
                />
              </GridLayout.Col>
            </GridLayout.Row>
          )}
          {!useSystemConfiguration && (
            <GridLayout.Row className='Izenda_GoogleSetting_ConfigInput Izenda_GoogleSetting_Address'>
              <GridLayout.Col cols={2}>
                <label className='u_marginLeft'>
                  {localization.getText('SYSTEM_CONFIGURATION_GOOGLE_MAP_ADDRESS')}
                </label>
                <a>
                  <span
                    className='icon-info-circled'
                    title={localization.getText('SYSTEM_CONFIGURATION_GOOGLE_MAP_ADDRESS_TOOLTIP')}
                  />
                </a>
              </GridLayout.Col>
              <GridLayout.Col cols={10}>
                <IzendaSwitch
                  id="izenda-google-address"
                  value={useGEOCodingService}
                  onChange={this.onChangeGoogleAddress}
                />
              </GridLayout.Col>
            </GridLayout.Row>
          )}
        </GridLayout>
      </Panel>
    );
  }

  componentWillUnmount() {
    this.props.store.destroy();
    this.props.resetAlert();
    this.disposeObserveTenantID();
  }

  componentDidMount() {
    const { store, loader } = this.props;
    store.init();
    loader.startLoading();
    store.loadGoogleMapConfiguration(uiState.tenantId).finally(loader.endLoading.bind(loader));
    this.disposeObserveTenantID = observe(uiState, 'tenantId', () => {
      store.loadGoogleMapConfiguration();
    });
  }

  render() {
    return (
      <div className='izenda-GoogleMapConfig'>
        <ScrollBox fullWidth>
          <SettingActionHeader {...this.props} />
          {this.renderGoogleMapConfigurationContent()}
        </ScrollBox>
      </div>
    );
  }

  onChangeGoogleAddress = (e: Event) => {
    this.props.onChangeGoogleMapSetting('useGEOCodingService', e.target.checked);
  };
}



// WEBPACK FOOTER //
// ./ui/modules/Settings/SystemConfiguration/GoogleMap/Izenda.GoogleMapConfiguration.js